/*global tinymce, jQuery */

;(function (tinymce, $) {
  'use strict';

  var A51Image = function (ed) {
    this.editor = ed;

    this.bookmark = {};

    this.options = $.extend({}, ed.getParam('a51image'));
    this.insert = this.options.insert || this.insert;

    if (this.options && (typeof this.options.upload === 'function')) {
      this.initUpload();

      var _this = this;

      this.editor.ui.registry.addButton('image', {
        icon: 'image',
        tooltip: 'Insert image',
        onAction: function() {
          if (_this.$fileInput && _this.$fileInput.length) {
            _this.$fileInput.trigger('click');
          }
        },
        stateSelector: 'img:not([data-mce-object],[data-mce-placeholder])'
      });
    }
  };

  A51Image.prototype = {

    constructor: A51Image,

    renderFileInput: function() {
      return '<input type="file" accept="image/*" id="a51image" style="width:0;height:0;overflow:hidden;" tabindex="-1"/>';
    },

    initUpload: function () {
      $(this.editor.targetElm).after(this.$fileInput = $(this.renderFileInput()));

      var _this = this;

      function processBlobImages(imgs) {
        let images = [];

        for (const img of imgs) {
          const url = img.src;
          const parts = url.split('/');
          const pseudoName = parts[parts.length - 1];
          const loaderId = 'a51image_loader_' + Date.now() + '_' + Math.floor(Math.random() * 10000) + '_' + pseudoName;

          const loader = _this.editor.dom.create('img', {
            'data-loader-id': loaderId,
            src: _this.options.loader_src,
            class: 'a51image_loading_indicator',
            alt: '...'
          });

          _this.editor.dom.replace(loader, img);
          images.push({ loaderId, img, loader });
        }

        for (const image of images) {
          getBlobImages(image.img).then(file => {
            _this.options.upload(
              [file],
              $.proxy(_this.selectBlob, _this, image.loader),
              function(item) {
                if (image.loader) {
                  _this.editor.dom.replace(
                    _this.editor.dom.create('img', { src: item.src }),
                    item.loader
                  );
                }
              }
            );
          });
        }
      }

      async function getBlobImages(img) {
        const url = img.src;
        const parts = url.split('/');
        let pseudoName = parts[parts.length - 1];
        const res = await fetch(img.src);
        const blob = await res.blob();

        if (!pseudoName.includes('.')) {
          const mimeToExt = {
            'image/jpeg': '.jpg',
            'image/png': '.png',
            'image/gif': '.gif',
            'image/bmp': '.bmp',
            'image/webp': '.webp',
            'image/vnd.wap.wbmp': '.wbmp',
            'image/x-xbitmap': '.xbm'
          };
          const extension = mimeToExt[blob.type] || '.jpg';
          pseudoName += extension;
        }

        return new File([blob], pseudoName, { type: blob.type });
      }

      function processUpload(files) {
        var loaderId = 'a51image_loader_' + Date.now() + '_' + Math.floor(Math.random() * 10000);


        if (files && files.length) {
          if (typeof _this.options.loader_src != undefined && _this.options.loader_src) {
            _this.editor.focus();
            setTimeout(function() {
              _this.bookmark[loaderId] = _this.editor.selection.getBookmark();
              _this.editor.execCommand('mceInsertContent', false, '<img data-loader-id="' + loaderId + '" src="' + _this.options.loader_src + '" class="a51image_loading_indicator" alt="..." />');
            }, 10)
          }

          _this.options.upload(
            files,
            $.proxy(_this.select, _this, loaderId),
            function(item) {
              setTimeout(function() {
                var loaderImgs = _this.editor.dom.select('img[data-loader-id="' + loaderId + '"]');
                if (loaderImgs && loaderImgs.length) {
                  _this.editor.dom.replace(
                    _this.editor.dom.create('img', { src: item.src }),
                    loaderImgs[0]
                  );
                }
                _this.$fileInput.val(null);
              }, 100);
            },
          );
        }
      }

      this.$fileInput.on('change', function () {
        processUpload(this.files);
      });

      this.editor.on('paste', function(e) {
        var data = e.clipboardData || e.dataTransfer;
        var i, item;
        var files = [];

        function processItems(items) {
          var containsImages = false;

          if (items) {
            for (i = 0; i < items.length; i++) {
              item = items[i];

              if (/^image\/(jpeg|png|gif|bmp)$/.test(item.type)) {
                var blob = item.getAsFile ? item.getAsFile() : item;
                files.push(blob);
                containsImages = true;
                e.preventDefault();
              }
            }
          }

          return containsImages;
        }

        if (_this.options.paste_images && (processItems(data.items)) || processItems(data.files)) {
          processUpload(files);
        }
      })

      this.editor.on('remove', function() {
        _this.$fileInput.remove();
      })

      this.editor.on('SetContent', async function (e) {
        const imgs = _this.editor.dom.select('img[src^="blob:"]');
        if (imgs.length) {
          await processBlobImages(imgs);
        }
      });

      this.editor.on('BeforeSetContent', function (e) {
        const match = e.content?.match(/<img[^>]+src=["']([^"']+)["']/i);
        if (!match) return;

        const src = match[1];

        const protocol = window.location.protocol;
        const hostname = window.location.hostname;
        const fullDomain = protocol + "//" + hostname;

        if (!src.startsWith(fullDomain) && src.includes("http://")) {
          e.preventDefault();
          _this.editor.insertContent(`<a href="${src}" data-mce-href="${src}">${src}</a>`);
        }
      });
    },
    selectBlob: function (loader, item) {
      if (loader) {
        this.editor.focus();

        const newImg = this.editor.dom.create('img', {
          src: item.src,
          'data-mce-src': item.src,
          'image-type': 'attachment',
          'object-id': item.code,
          'alt': item?.name
        });

        this.editor.dom.replace(
          newImg,
          loader
        );

        this.$fileInput.val(null);
      }
    },
    select: function (loaderId, item) {
      this.editor.focus();

      this.editor.dom.remove(this.editor.dom.select('img[data-loader-id="' + loaderId + '"]')[0]);
      const bookmarkBeforeInsert = this.editor.selection.getBookmark();

      this.editor.selection.moveToBookmark(this.bookmark[loaderId]);
      this.editor.execCommand('mceInsertContent', false, this.insert(item));
      this.$fileInput.val(null);
      delete this.bookmark[loaderId];
      this.editor.selection.moveToBookmark(bookmarkBeforeInsert);
    },

    insert: function (item) {
      return '<img src="' + item['src'] + '" />';
    }
  };

  tinymce.PluginManager.add('a51image', function(ed, url){
    new A51Image(ed);
  });
})(tinymce, jQuery);
